// extracted by mini-css-extract-plugin
export default {"calendarWidget":"WhenForm_calendarWidget__QyMoy"};